import { render } from "./India.vue?vue&type=template&id=ec97514c"
import script from "./India.vue?vue&type=script&lang=js"
export * from "./India.vue?vue&type=script&lang=js"

import "./India.vue?vue&type=style&index=0&id=ec97514c&lang=css"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__